import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import StatusChanger from "../status-chenger";
import { Link } from "react-router-dom";
import { FaPencilAlt } from "react-icons/fa";
import { errorToaster } from "../../../../helper/toasterConfiguration";
import { Button } from "@mui/material";
import CountTicketChanger from "./count-ticket-changer";
import Data from "../../../common/custom-modal/Data";
import jsPDF from "jspdf";
import "jspdf-autotable";

const DataTable = ({
  data,
  setData,
  rowsPerPage,
  currentPage,
  status,
}) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  const handleDownload = async (report) => {
    try {
      const link = document.createElement("a");
      link.href = report;
      link.setAttribute("download", "image.jpg");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      errorToaster(error || "Failed to download report");
    }
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Ticket Data Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [
        [
          "ID",
          "Order ID",
          "Panel URL",
          "Days Subscription",
          "Active Start Date",
          "Days Active",
          "Status",
        ],
      ],
      body: sortedData.map((item) => [
        item?.id,
        item?.request_id,
        item?.panel_url,
        item?.count_days_subscriptions || "N/A",
        item?.date_start_active,
        item?.count_days_active,
        item?.status,
      ]),
    });
    doc.save("ticket-data-table.pdf");
  };

  return (
    <>
      <Button variant="contained" style={{ marginBottom: "20px" }} color="primary" onClick={exportPDF}>
        Export PDF
      </Button>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {[
                { label: "ID", field: "id" },
                { label: "Order ID", field: "request_id" },
                { label: "Panel URL", field: "panel_url" },
                { label: "Days Subscription", field: "count_days_subscriptions" },
                { label: "Active Start Date", field: "date_start_active" },
                { label: "Days Active", field: "count_days_active" },
                { label: "Status", field: "status" },
              ].map((column) => (
                <TableCell
                  key={column.field}
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                  sortDirection={orderBy === column.field ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === column.field}
                    direction={orderBy === column.field ? order : "asc"}
                    onClick={() => handleSort(column.field)}
                  >
                    {column.label}
                  </TableSortLabel>
                </TableCell>
              ))}
              {/*<TableCell*/}
              {/*  align="center"*/}
              {/*  className="!text-darkTextColor whitespace-nowrap"*/}
              {/*>*/}
              {/*  Actions*/}
              {/*</TableCell>*/}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" align="center">
                  {item?.id}
                </TableCell>
                <TableCell align="center">{item?.request_id}</TableCell>
                <TableCell align="center">
                  <a
                    href={item?.panel_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item?.panel_url}
                  </a>
                </TableCell>
                <TableCell align="center">
                  {item?.count_days_subscriptions || "N/A"}
                </TableCell>
                <TableCell align="center">{item?.date_start_active}</TableCell>
                <TableCell align="center">{item?.count_days_active}</TableCell>
                <TableCell align="center">
                  <StatusChanger
                    data={item}
                    setData={setData}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    status={status}
                  />
                </TableCell>
                {/*<TableCell align="center">*/}
                {/*  <div className="flex gap-x-10 text-lg items-center justify-center">*/}
                {/*    <Link*/}
                {/*      to={`/Trust/Edit/${item?.id}`}*/}
                {/*      color="inherit"*/}
                {/*      underline="none"*/}
                {/*    >*/}
                {/*      <FaPencilAlt className="text-[#6c757d]" />*/}
                {/*    </Link>*/}
                {/*  </div>*/}
                {/*</TableCell>*/}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTable;
